import { FormikError } from '@nv/basic-components'
import { useTranslation } from 'react-i18next'
import ReactPhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import styles from './PhoneInput.module.scss'

export const PhoneInput = ({ field, formik, label, isRequired = false, autoComplete = 'off', disabled = false }: any) => {
  const { t } = useTranslation()
  const phoneValue = formik.values[field]
  const showError = formik.touched[field] && phoneValue && !isValidPhoneNumber(phoneValue)

  return (
    <div className={styles['container']}>
      <label htmlFor={field} className={styles['label']}>
        {label || t('form.labels.phoneNumber')} {isRequired && <span className={styles['label--required']}>*</span>}
      </label>

      <ReactPhoneInput
        id={field}
        name={field}
        defaultCountry='CA'
        className={`${styles['input']} ${disabled ? styles['input--disabled'] : ''}`}
        value={phoneValue}
        onChange={(value) => formik.setFieldValue(field, value)}
        onBlur={() => formik.setFieldTouched(field, true)}
        international
        autoComplete={autoComplete}
        disabled={disabled}
        aria-describedby={showError ? `${field}-error` : undefined}
      />

      {showError && (
        <div role='alert' id={`${field}-error`} className={styles['error']}>
          {t('form.validations.invalidPhoneSuggestion')}
        </div>
      )}

      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
